import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // Sticky at the top of the list: the selection can run past a screenful, and
  // an action bar that scrolls away leaves the operator holding a selection
  // with no way to act on it.
  bar: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(1),
    // Same two silent failure modes `gap` has elsewhere in this feature, and
    // the same fallback: flex-container gap is Safari 14.1+, so without this
    // the buttons render flush against each other, which is a mis-click risk.
    '& > *:not(:last-child)': { marginInlineEnd: theme.spacing(1) },
    '@supports (gap: 8px)': {
      '& > *:not(:last-child)': { marginInlineEnd: 0 }
    }
  },
  count: { fontWeight: 700 }
}))

export default useStyles
